<template>

  <v-container fluid>

    <!-- 업로드 프로그레스 -->
    <comloading :isVisible="progress_dialog" :progress="progress_value" />

    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="cancel_crop" max-width="1000px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:100%;min-height:50vh">
              <vue-cropper
                  ref="cropper_land"
                  :key="option.autoCropWidth + '_' + option.autoCropHeight"
                  :src="imgSrc"
                  :aspect-ratio="option.autoCropWidth/option.autoCropHeight"
                  />
            </div>
            
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-col cols="2">
              </v-col>
              <v-col cols="8" align="center">
                <v-btn class="dialog_cancel_btn mr-5" rounded small @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
                <v-btn class="dialog_btn" rounded small @click="cropimg">{{$t("common_ok")}}</v-btn>
              </v-col>
              <v-col cols="2">
                <v-btn style="width:200px !important" color="dialog_btn mr-5" v-if="!option.fixed" rounded small @click="fitCropToImage">{{$t("common_fit")}}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>    

    <v-row align="center" dense no-gutters>
      <v-col cols="3">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="3">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      <v-col cols="3">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>      
    </v-row>

    <v-row dense align="start">

    <v-col cols="12" md="5">
      
        <v-col cols="12" align="end" class="d-flex">
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" color="primary" width="120" elevation="0"  large @click="loadinfo_deploy">{{$t('pagesetinfo_col61')}}</v-btn>
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" color="primary" width="100" elevation="0" class="ml-1" large @click="deploy_popup">{{$t('pagesetinfo_col63')}}</v-btn>
          <v-spacer/>
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="yellow_btn" elevation="0" outlined large @click="loadinfo">{{$t('pagesetinfo_col45')}}</v-btn>
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="yellow_btn ml-1" elevation="0" outlined large @click="add_section">{{$t('common_insert')}}</v-btn>
          <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="yellow_btn ml-1" elevation="0" outlined large @click="save">{{$t('common_save2')}}</v-btn>
        </v-col>
      
        <v-col cols="12" class="pt-0">
          <draggable v-model="editedItem.PAGE_INFO">
            <v-data-table
                :headers="headers"
                :items="editedItem.PAGE_INFO"
                hide-default-footer
                :items-per-page="9999"
                :no-data-text="$t('eventformat_msg17')"
                :no-results-text="$t('eventformat_msg18')"
                class="datatablestyle"
                item-key="name"
                :loading="loading"
                >
                <template v-slot:header.PAGE_NAME>
                  <label class="cheader_normal" >{{$t("pagemain_col1")}}</label>
                </template>
                <template v-slot:header.COPY>
                  <label class="cheader_normal" >{{$t("pagemain_col105")}}</label>
                </template>
                <template v-slot:header.USETYPE>
                  <label class="cheader_normal" >{{$t("pagemain_col2")}}</label>
                </template>

              <template v-slot:body="props">
                <draggable :list="props.items" ghost-class="ghost" @change="changedrag" tag="tbody">
                  <tr v-for="(item, index) in props.items" :key="index">
                    <td style="width:50px; text-align:center"><v-icon small>mdi-drag</v-icon></td>
                    <td style="width:250px; text-align:center">
                      <a class="mr-2" small @click="loaddetail(item)">{{ item.TITLE }}</a>
                    </td>
                    <td style="width:80px; text-align:center">
                      <v-icon style="cursor:pointer;" size="20" color="primary" @click="copy(item)">mdi-content-copy</v-icon>
                    </td>
                    <td style="width:80px; text-align:center">
                      <input type="checkbox" dense v-model="item.USETYPE" hide-details/>
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-data-table>
          </draggable>
        </v-col>
      
    </v-col>


    <v-col v-if="PARENT_ITEM != null && PARENT_ITEM.TITLE != null" cols="12" md="7" style="height:80vh;overflow:auto">

      <!-- 섹션 정보 -->
      <div style="position:relative;" class="mt-3">
        <div class="input_title w-100">{{$t('pagemain_col3')}}</div>
        <v-icon style="position:absolute; bottom:8px; right:8px;cursor:pointer" @click="delete_section(PARENT_ITEM)">mdi-delete</v-icon>
      </div>
      <div class="d-flex flex-row mt-2">
        <div class="input_title">{{ $t("pagemain_col1") }}</div>
        <input
          v-model="PARENT_ITEM.TITLE" 
          class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
          :placeholder="$t('pagemain_col4')"
          />
      </div>
      <div class="d-flex flex-row mt-2">
        <label class="input_title">{{$t("pagemain_col5")}}</label>
        <v-select 
          v-model="PARENT_ITEM.PCBG_TYPE" :items="URLTYPELIST" :placeholder="$t('pagemain_col110')" 
          item-text="name" item-value="value" outlined dense 
          hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
          bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
          />
      </div>            
      <div style="height:140px" v-if="PARENT_ITEM.PCBG_TYPE == 1">
        <dialogbgcolor 
          dense :title="$t('pagemain_col6')" ref="bgcolor" 
          :color="PARENT_ITEM.PCBG_COLOR" :obj="PARENT_ITEM"
          path="PCBG_COLOR"
          @callback="callback_value"
          />
      </div>

      <div class="mt-1" v-if="PARENT_ITEM.PCBG_TYPE == 2">
        <div class="input_title w-100">{{$t("pagemain_col7")}}</div>
      </div>
      <div class="mt-1" style="height:140px" v-if="PARENT_ITEM.PCBG_TYPE == 2">
        <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
            @click="fileSelect(`SECTION.${PARENT_ITEM.INDEX}.PCBG_URL`, 1920, 912)"
            >
            <img 
              height="120"
              :src="getNestedProperty(previewImg, `SECTION.${PARENT_ITEM.INDEX}.PCBG_URL`)"
              class="image" style="cursor:pointer"
              />
            <v-icon style="position:absolute; bottom:8px; right:8px; cursor:pointer;">
              mdi-pencil
            </v-icon>
        </div>
      </div>        
      <div v-if="PARENT_ITEM.PCBG_TYPE > 2">
        <div class="d-flex flex-row mt-2">
          <div class="input_title">{{$t("pagemain_col8")}}</div>
          <input
            v-model="PARENT_ITEM.PCBG_URL" 
            class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('pagemain_col69')"
            />
        </div>
      </div>

      <div class="d-flex flex-row mt-2">
        <label class="input_title">{{$t("pagemain_col9")}}</label>
        <v-select 
          v-model="PARENT_ITEM.MBBG_TYPE" :items="URLTYPELIST" :placeholder="$t('pagemain_col110')" 
          item-text="name" item-value="value" outlined dense 
          hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
          bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
          />
      </div>            
      <div style="height:140px" v-if="PARENT_ITEM.MBBG_TYPE == 1">
        <dialogbgcolor 
          dense :title="$t('pagemain_col10')" ref="bgcolor" 
          :color="PARENT_ITEM.MBBG_COLOR" :obj="PARENT_ITEM"
          path="MBBG_COLOR"
          @callback="callback_value"
          />
      </div>

      <div class="mt-1" v-if="PARENT_ITEM.MBBG_TYPE == 2">
        <div class="input_title w-100">{{$t("pagemain_col11")}}</div>
      </div>
      <div class="mt-1" style="height:140px" v-if="PARENT_ITEM.MBBG_TYPE == 2">
        <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
            @click="fileSelect(`SECTION.${PARENT_ITEM.INDEX}.MBBG_URL`, 460, 912)"
            >
            <img 
              height="120"
              :src="getNestedProperty(previewImg, `SECTION.${PARENT_ITEM.INDEX}.MBBG_URL`)"
              class="image" style="cursor:pointer"
              @click="showImage(previewImg, `SECTION.${PARENT_ITEM.INDEX}.MBBG_URL`)"
              />
            <v-icon style="position:absolute; bottom:8px; right:8px; cursor:pointer;">
              mdi-pencil
            </v-icon>
        </div>
      </div>        
      <div v-if="PARENT_ITEM.MBBG_TYPE > 2">
        <div class="d-flex flex-row mt-2">
          <div class="input_title">{{$t("pagemain_col8")}}</div>
          <input
            v-model="PARENT_ITEM.MBBG_URL" 
            class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('pagemain_col69')"
            />
        </div>
      </div>             

      
      <div class="d-flex flex-row mt-2 align-center">
        <div class="input_title">{{$t("pagemain_col12")}}</div>
        <input
          v-model="PARENT_ITEM.PC_LEFT" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="LEFT"
          />
        <input
          v-model="PARENT_ITEM.PC_TOP" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="TOP"
          />
        <input
          v-model="PARENT_ITEM.PC_RIGHT" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="RIGHT"
          />
        <input
          v-model="PARENT_ITEM.PC_BOTTOM" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="BOTTOM"
          />
        <div class="ml-5" style="font-size:12px">{{ $t('pagemain_col109')}}</div>
      </div>

      <div class="d-flex flex-row mt-2">
        <div class="input_title">{{$t("pagemain_col13")}}</div>
        <input
          v-model="PARENT_ITEM.MB_LEFT" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="LEFT"
          />
        <input
          v-model="PARENT_ITEM.MB_TOP" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="TOP"
          />
        <input
          v-model="PARENT_ITEM.MB_RIGHT" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="RIGHT"
          />
        <input
          v-model="PARENT_ITEM.MB_BOTTOM" type="number"
          class="input_nowidth" style="width:80px !important"
          placeholder="BOTTOM"
          />
      </div>

      <div class="d-flex flex-row mt-2">
        <div class="input_title">{{$t("pagemain_col14")}}</div>
        <v-select 
          v-model="PARENT_ITEM.USEFIX" :items="SHOWTYPELIST" :placeholder="$t('pagemain_col14')" 
          item-text="name" item-value="value" outlined dense 
          hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
          bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
          />
      </div>

      <!-- 컴포넌트 정보 -->
      <v-col cols="12" class="d-flex align-center mt-5 pa-0" style="position:relative;">
        <div class="input_title w-100">{{$t('pagemain_col15')}}</div>
      </v-col>

      <draggable v-model="PARENT_ITEM.COMPONENT" :group="'component'" handle=".handle" @change="changedragupdate">
      <v-col v-for="(component, index) in PARENT_ITEM.COMPONENT" :key="index">
        
        <div class="d-flex flex-row mt-2 mb-2">
          <div class="d-flex align-center input_title">
            <v-icon class="handle" style="cursor:pointer">mdi-drag</v-icon>
            <label>{{$t('pagemain_col16')}}</label>
          </div>
          <v-select 
            v-model="component.COMPONENT_TYPE" :items="CPTYPELIST" :placeholder="$t('pagemain_col16')" 
            :item-text="$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined dense 
            hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
            bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
            @change="changetype(component)"
            />
          <v-spacer/>
          <v-icon  @click="copy_component(component)">mdi-content-copy</v-icon>
          <v-icon  @click="delete_component(component)">mdi-delete</v-icon>
        </div>            

        <!-- 타이틀 -->
        <template v-if="component.COMPONENT_TYPE == 'TITLE'">

          <div class="d-flex flex-row">
            <div class="input_title">{{$t('pagemain_col17')}}</div>
            <input
              v-model="component.TITLE" 
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col18')"
              />
            <dialogcolor 
              dense :title="$t('pagemain_col18')" class="ml-1" style="width:30px"
              :color="component.TITLE_FONT.COLOR" :obj="component"
              path="TITLE_FONT.COLOR" 
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col18')" class="ml-1" style="width:30px"
              :size="component.TITLE_FONT.PCSIZE" :obj="component"
              path="TITLE_FONT.PCSIZE"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col18')" class="ml-1" style="width:30px"
              :size="component.TITLE_FONT.MBSIZE" :obj="component"
              path="TITLE_FONT.MBSIZE"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col18')" class="ml-1" style="width:30px"
              :size="component.TITLE_FONT.LINEHEIGHT" :obj="component"
              path="TITLE_FONT.LINEHEIGHT"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.TITLE_FONT.ALIGN" :obj="component"
              path="TITLE_FONT.ALIGN"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.TITLE_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>

        </template>
        <!-- 텍스트 -->
        <template v-else-if="component.COMPONENT_TYPE == 'TEXT'">

          <div class="d-flex flex-row">
            <div class="input_title">{{$t('pagemain_col19')}}</div>
            <v-spacer/>
            <dialogcolor 
              dense :title="$t('pagemain_col19')" class="ml-1" style="width:30px"
              :color="component.TEXT_FONT.COLOR" 
              path="TEXT_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col19')" class="ml-1" style="width:30px"
              :size="component.TEXT_FONT.PCSIZE" 
              path="TEXT_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col19')" class="ml-1" style="width:30px"
              :size="component.TEXT_FONT.MBSIZE" 
              path="TEXT_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col19')" class="ml-1" style="width:30px"
              :size="component.TEXT_FONT.LINEHEIGHT" 
              path="TEXT_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.TEXT_FONT.ALIGN" 
              path="TEXT_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.TEXT_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>
          <div class="d-flex flex-row mt-1">
            <v-textarea
              v-model="component.TEXT" 
              outlined
              style="white-space:pre-line;width:100%"
              rows="3" bg-color="#ffffff" 
              type="text" color="#FF6000"
              :placeholder="$t('pagemain_col20')"
              dense single-line hide-details
              />
          </div>            

        </template>
        <!-- 포스터 -->
        <template v-else-if="component.COMPONENT_TYPE == 'POSTER'">
          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col21')}}</label>
            <v-select 
              v-model="component.POSTER_ANITYPE" :items="ANITYPELIST" :placeholder="$t('pagemain_col21')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
              <label class="input_title ml-2">{{$t('pagemain_col22')}}</label>
              <v-select 
                v-model="component.POSTER_ALIGN" :items="ALIGNTYPELIST" :placeholder="$t('pagemain_col22')" 
                item-text="name" item-value="value" outlined dense 
                hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
                bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
                />
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col23')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col23')" class="ml-1" style="width:30px"
              :color="component.POSTER_TITLE_FONT.COLOR" 
              path="POSTER_TITLE_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col23')" class="ml-1" style="width:30px"
              :size="component.POSTER_TITLE_FONT.PCSIZE" 
              path="POSTER_TITLE_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col23')" class="ml-1" style="width:30px"
              :size="component.POSTER_TITLE_FONT.MBSIZE" 
              path="POSTER_TITLE_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col23')" class="ml-1" style="width:30px"
              :size="component.POSTER_TITLE_FONT.LINEHEIGHT" 
              path="POSTER_TITLE_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.POSTER_TITLE_FONT.ALIGN" 
              path="POSTER_TITLE_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.POSTER_TITLE_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col24')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col24')" class="ml-1" style="width:30px"
              :color="component.POSTER_DESC_FONT.COLOR" 
              path="POSTER_DESC_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col24')" class="ml-1" style="width:30px"
              :size="component.POSTER_DESC_FONT.PCSIZE" 
              path="POSTER_DESC_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col24')" class="ml-1" style="width:30px"
              :size="component.POSTER_DESC_FONT.MBSIZE" 
              path="POSTER_DESC_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col24')" class="ml-1" style="width:30px"
              :size="component.POSTER_DESC_FONT.LINEHEIGHT" 
              path="POSTER_DESC_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.POSTER_DESC_FONT.ALIGN" 
              path="POSTER_DESC_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.POSTER_DESC_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            
          
          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col25')}}</label>
            <v-select 
              v-model="component.POSTER_BTN_USE" :items="BTNUSETYPELIST" :placeholder="$t('pagemain_col25')" 
              item-text="name" item-value="value" outlined dense @change="changedragupdate"
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
            <label class="input_title ml-2">{{$t('pagemain_col103')}}</label>
            <v-select 
              v-model="component.POSTER_EFFECT" :items="USETYPELIST" :placeholder="$t('pagemain_col22')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
          </div>
          <div class="d-flex flex-row mt-2" v-if="component.POSTER_BTN_USE == 1">
            <div class="input_title">{{$t('pagemain_col26')}}</div>
            <input
              v-model="component.POSTER_BTN" 
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col27')"
              />
            <dialogcolor 
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :color="component.POSTER_BTN_FONT.COLOR" 
              path="POSTER_BTN_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTN_FONT.PCSIZE" 
              path="POSTER_BTN_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTN_FONT.MBSIZE" 
              path="POSTER_BTN_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTN_FONT.LINEHEIGHT" 
              path="POSTER_BTN_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.POSTER_BTN_FONT.ALIGN" 
              path="POSTER_BTN_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.POSTER_BTN_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            

          <div class="d-flex flex-row mt-2" v-if="component.POSTER_BTN_USE == 1">
            <div class="input_title">{{$t('pagemain_col95')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col95')" class="ml-1" style="width:30px"
              :color="component.POSTER_BTNCOLOR" :obj="component"
              path="POSTER_BTNCOLOR" 
              @callback="callback_value"
              />
          </div>
          <div class="d-flex flex-row mt-2" v-if="component.POSTER_BTN_USE == 1">
            <div class="input_title">{{$t('pagemain_col96')}}</div>
            <dialogfontsize 
              dense :title="$t('pagemain_col96')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTNPCROUND" :obj="component"
              path="POSTER_BTNPCROUND"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col96')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTNMBROUND" :obj="component"
              path="POSTER_BTNMBROUND"
              @callback="callback_value"
              />                
          </div>
          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col97')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col97')" class="ml-1" style="width:30px"
              :color="component.POSTER_BTNLINECOLOR" :obj="component"
              path="POSTER_BTNLINECOLOR" 
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col98')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTNPCWIDTH" :obj="component"
              path="POSTER_BTNPCWIDTH"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col98')" class="ml-1" style="width:30px"
              :size="component.POSTER_BTNMBWIDTH" :obj="component"
              path="POSTER_BTNMBWIDTH"
              @callback="callback_value"
              />                
          </div>

          <div class="input_title w-100 mt-2 mb-2">{{$t('pagemain_col29')}}</div>  
          <draggable v-model="component.POSTERLIST" :group="'poster'" handle=".handle" @change="changedragupdate">
          <div v-for="(item, index) in component.POSTERLIST" :key="index">

            <div class="mt-1" style="height:120px">
              <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                  @click="fileSelect(`COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`, 325, 450)"
                  >
                  <img 
                    height="120"
                    :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`)"
                    class="image" style="cursor:pointer"
                    />
                  <!-- @click="showImage(previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`)" -->
                  <v-icon class="handle" style="position:absolute; bottom:8px; left:8px;cursor:pointer">mdi-drag</v-icon>
                  <v-icon style="position:absolute; bottom:8px; right:8px;cursor:pointer" @click.stop="delete_poster(component, item)">mdi-delete</v-icon>
                  <v-icon style="position:absolute; bottom:8px; right:38px; cursor:pointer;">
                    mdi-pencil
                  </v-icon>
              </div>
            </div>        

            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col30')}}</div>
              <v-textarea
                v-model="item.POSTER_TITLE" 
                outlined class="ml-2"
                style="white-space:pre-line;width:100%"
                rows="3" bg-color="#ffffff" 
                type="text" color="#FF6000"
                :placeholder="$t('pagemain_col31')"
                dense single-line hide-details
                />
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col32')}}</div>
              <v-textarea
                v-model="item.POSTER_DESC" 
                outlined class="ml-2"
                style="white-space:pre-line;width:100%"
                rows="3" bg-color="#ffffff" 
                type="text" color="#FF6000"
                :placeholder="$t('pagemain_col33')"
                dense single-line hide-details
                />
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col34')}}</div>
              <input
                v-model="item.POSTER_LINK" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagemain_col35')"
                />
            </div>

          </div>
          </draggable>

          <div class="d-flex justify-center mt-2">
            <v-btn @click="add_poster_info(component)">{{$t('pagemain_col36')}}</v-btn> 
          </div>
        </template>
        <!-- 분할 -->
        <template v-else-if="component.COMPONENT_TYPE == 'SPLIT'">

          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col37')}}</label>
            <v-select 
              v-model="component.SPLIT_LEFTCONTENT" :items="SPLITTYPELIST" :placeholder="$t('pagemain_col37')" 
              :item-text="$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
            <label class="input_title ml-2">{{$t('pagemain_col38')}}</label>
            <v-select 
              v-model="component.SPLIT_DIVTYPE" :items="DIVTYPELIST" :placeholder="$t('pagemain_col38')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col39')}}</div>
            <input
              v-model="component.SPLIT_TITLE" 
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col40')"
              />
            <dialogcolor 
              dense :title="$t('pagemain_col39')" class="ml-1" style="width:30px"
              :color="component.SPLIT_TITLE_FONT.COLOR" 
              path="SPLIT_TITLE_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col39')" class="ml-1" style="width:30px"
              :size="component.SPLIT_TITLE_FONT.PCSIZE" 
              path="SPLIT_TITLE_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize2 
              dense :title="$t('pagemain_col39')" class="ml-1" style="width:30px"
              :size="component.SPLIT_TITLE_FONT.MBSIZE" 
              path="SPLIT_TITLE_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />
            <dialoglineheight 
              dense :title="$t('pagemain_col39')" class="ml-1" style="width:30px"
              :size="component.SPLIT_TITLE_FONT.LINEHEIGHT" 
              path="SPLIT_TITLE_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.SPLIT_TITLE_FONT.ALIGN" 
              path="SPLIT_TITLE_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.SPLIT_TITLE_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col41')}}</div>
            <v-spacer/>
            <dialogcolor 
              dense :title="$t('pagemain_col41')" class="ml-1" style="width:30px"
              :color="component.SPLIT_DESC_FONT.COLOR" 
              path="SPLIT_DESC_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col41')" class="ml-1" style="width:30px"
              :size="component.SPLIT_DESC_FONT.PCSIZE" 
              path="SPLIT_DESC_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col41')" class="ml-1" style="width:30px"
              :size="component.SPLIT_DESC_FONT.MBSIZE" 
              path="SPLIT_DESC_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col41')" class="ml-1" style="width:30px"
              :size="component.SPLIT_DESC_FONT.LINEHEIGHT" 
              path="SPLIT_DESC_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.SPLIT_DESC_FONT.ALIGN" 
              path="SPLIT_DESC_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />

            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.SPLIT_DESC_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>
          <div class="d-flex flex-row mt-1">
            <v-textarea
              v-model="component.SPLIT_DESC" 
              outlined
              style="white-space:pre-line;width:100%"
              rows="3" bg-color="#ffffff" 
              type="text" color="#FF6000"
              :placeholder="$t('pagemain_col42')"
              dense single-line hide-details
              />
          </div>            

          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col25')}}</label>
            <v-select 
              v-model="component.SPLIT_BTN_USE" :items="USETYPELIST" :placeholder="$t('pagemain_col25')" 
              item-text="name" item-value="value" outlined dense @change="changedragupdate"
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
          </div>
          <div class="d-flex flex-row mt-2" v-if="component.SPLIT_BTN_USE == 1">
            <div class="input_title">{{$t('pagemain_col26')}}</div>
            <input
              v-model="component.SPLIT_BTN" 
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col27')"
              />
            <dialogcolor 
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :color="component.SPLIT_BTN_FONT.COLOR" 
              path="SPLIT_BTN_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :size="component.SPLIT_BTN_FONT.PCSIZE" 
              path="SPLIT_BTN_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :size="component.SPLIT_BTN_FONT.MBSIZE" 
              path="SPLIT_BTN_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col28')" class="ml-1" style="width:30px"
              :size="component.SPLIT_BTN_FONT.LINEHEIGHT" 
              path="SPLIT_BTN_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.SPLIT_BTN_FONT.ALIGN" 
              path="SPLIT_BTN_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.SPLIT_BTN_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            
          <div class="d-flex flex-row mt-2" v-if="component.SPLIT_BTN_USE == 1">
            <div class="input_title">{{$t('pagemain_col102')}}</div>
            <input
              v-model="component.SPLIT_BTN_URL" 
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col102')"
              />
          </div>
          
          <div class="d-flex flex-row mt-2 align-center">
            <label class="input_title">{{$t('pagemain_col43')}}</label>
            <v-select 
              v-model="component.PCBG_TYPE" :items="CONTENTTYPELIST" :placeholder="$t('pagemain_col43')" 
              item-text="name" item-value="value" outlined dense @change="changedragupdate"
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
            <a v-if="component.PCBG_TYPE == 1" class="ml-10"
              target="_blank" href="https://pie-bayberry-02f.notion.site/FAIRPASS-PC-1b3454ba2ae980fc84a8f0f9acf58e15">
              {{ $t('pagesetinfo_col57') }}
            </a>
          </div>            
          <div class="mt-1" v-if="component.PCBG_TYPE == 0">
            <div class="input_title w-100">{{$t('pagemain_col44')}}</div>
          </div>
          <div class="mt-1" style="height:140px" v-if="component.PCBG_TYPE == 0">
            <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                @click="fileSelect(`COMPONENT.${component.INDEX}.PCBG_URL`, null, null)"
                >
                <img 
                  height="120"
                  :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`)"
                  class="image" style="cursor:pointer"
                  />
                <v-icon style="position:absolute; bottom:8px; right:8px; cursor:pointer;">
                  mdi-pencil
                </v-icon>
            </div>
          </div>        
          <div v-if="component.PCBG_TYPE > 0">
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col8')}}</div>
              <input
                v-model="component.PCBG_URL" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagemain_col69')"
                />
            </div>
          </div>

          <div class="d-flex flex-row mt-2 align-center">
            <label class="input_title">{{$t('pagemain_col45')}}</label>
            <v-select 
              v-model="component.MBBG_TYPE" :items="CONTENTTYPELIST" :placeholder="$t('pagemain_col45')" 
              item-text="name" item-value="value" outlined dense @change="changedragupdate"
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
            <a v-if="component.MBBG_TYPE == 1" class="ml-10"
              target="_blank" href="https://pie-bayberry-02f.notion.site/FAIRPASS-PC-1b3454ba2ae980fc84a8f0f9acf58e15">
              {{ $t('pagesetinfo_col57') }}
            </a>

          </div>            

          <div class="mt-1" v-if="component.MBBG_TYPE == 0">
            <div class="input_title w-100">{{$t('pagemain_col46')}}</div>
          </div>
          <div class="mt-1" style="height:140px" v-if="component.MBBG_TYPE == 0">
            <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                @click="fileSelect(`COMPONENT.${component.INDEX}.MBBG_URL`, null, null)"
                >
                <img 
                  height="120"
                  :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`)"
                  class="image" style="cursor:pointer"
                  />
                <v-icon style="position:absolute; bottom:8px; right:8px; cursor:pointer;">
                  mdi-pencil
                </v-icon>
            </div>
          </div>        
          <div v-if="component.MBBG_TYPE > 0">
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col8')}}</div>
              <input
                v-model="component.MBBG_URL" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagemain_col69')"
                />
            </div>
          </div>                            

        </template>
        <!-- 공지 -->
        <template v-else-if="component.COMPONENT_TYPE == 'NOTICE'">
          
          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col47')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col47')" class="ml-1" style="width:30px"
              :color="component.NOTICE_TITLE_FONT.COLOR" 
              path="NOTICE_TITLE_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col47')" class="ml-1" style="width:30px"
              :size="component.NOTICE_TITLE_FONT.PCSIZE" 
              path="NOTICE_TITLE_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col47')" class="ml-1" style="width:30px"
              :size="component.NOTICE_TITLE_FONT.MBSIZE" 
              path="NOTICE_TITLE_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col47')" class="ml-1" style="width:30px"
              :size="component.NOTICE_TITLE_FONT.LINEHEIGHT" 
              path="NOTICE_TITLE_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.NOTICE_TITLE_FONT.ALIGN" 
              path="NOTICE_TITLE_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.NOTICE_TITLE_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col48')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col48')" class="ml-1" style="width:30px"
              :color="component.NOTICE_DESC_FONT.COLOR" 
              path="NOTICE_DESC_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col48')" class="ml-1" style="width:30px"
              :size="component.NOTICE_DESC_FONT.PCSIZE" 
              path="NOTICE_DESC_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col48')" class="ml-1" style="width:30px"
              :size="component.NOTICE_DESC_FONT.MBSIZE" 
              path="NOTICE_DESC_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col48')" class="ml-1" style="width:30px"
              :size="component.NOTICE_DESC_FONT.LINEHEIGHT" 
              path="NOTICE_DESC_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.NOTICE_DESC_FONT.ALIGN" 
              path="NOTICE_DESC_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.NOTICE_DESC_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            

          <div class="input_title w-100 mt-2 mb-2">{{$t('pagemain_col49')}}</div>  
          <draggable v-model="component.NOTICELIST" :group="'poster'" handle=".handle" @change="changedragupdate">
          <div v-for="(item, index) in component.NOTICELIST" :key="index">

            <div class="d-flex flex-row mt-2">
              <div style="position:relative">
                <v-icon style="position:absolute; bottom:8px; left:8px;cursor:pointer" class="handle">mdi-drag</v-icon>
                <div class="input_title">{{$t('pagemain_col39')}}</div>
              </div>
              <input
                v-model="item.NOTICE_TITLE" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagemain_col40')"
                />
              <v-icon @click="delete_notice(component, item)">mdi-delete</v-icon>
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col41')}}</div>
              <v-textarea
                v-model="item.NOTICE_DESC" 
                outlined class="ml-2"
                style="white-space:pre-line;width:100%"
                rows="3" bg-color="#ffffff" 
                type="text" color="#FF6000"
                :placeholder="$t('pagemain_col42')"
                dense single-line hide-details
                />
            </div>

          </div>
          </draggable>

          <div class="d-flex justify-center mt-2">
            <v-btn @click="add_notice_info(component)">{{$t('pagemain_col50')}}</v-btn> 
          </div>                       

        </template>
        <!-- 이미지 -->
        <template v-else-if="component.COMPONENT_TYPE == 'IMAGE'">
          
          <div class="mt-1" >
            <div class="input_title w-100">{{$t('pagemain_col51')}}</div>
          </div>
          <div class="mt-1" style="height:140px">
            <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                @click="fileSelect(`COMPONENT.${component.INDEX}.PCBG_URL`, null, null)"
                >
                <img 
                  height="120"
                  :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`)"
                  class="image" style="cursor:pointer"
                  />
                <v-icon 
                  style="position:absolute; bottom:8px; right:8px; cursor:pointer;"
                  >
                  mdi-pencil
                </v-icon>
            </div>
          </div>        

          <div class="mt-1" >
            <div class="input_title w-100">{{$t('pagemain_col52')}}</div>
          </div>
          <div class="mt-1" style="height:140px" >
            <div style="height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                @click="fileSelect(`COMPONENT.${component.INDEX}.MBBG_URL`, null, null)"
                >
                <img 
                  height="120"
                  :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`)"
                  class="image" style="cursor:pointer"
                  />
                <v-icon style="position:absolute; bottom:8px; right:8px; cursor:pointer;">
                  mdi-pencil
                </v-icon>
            </div>
          </div>                    

        </template>
        <!-- 연사소개 -->
        <template v-else-if="component.COMPONENT_TYPE == 'PEOPLE'">
        
          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col21')}}</label>
            <v-select 
              v-model="component.PEOPLE_ANITYPE" :items="ANITYPELIST" :placeholder="$t('pagemain_col21')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
              <!-- 
              <label class="input_title ml-2">{{$t('pagemain_col53')}}</label>
              <v-select 
                v-model="component.PEOPLE_ALIGN" :items="ALIGNTYPELIST" :placeholder="$t('pagemain_col53')" 
                item-text="name" item-value="value" outlined dense 
                hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
                bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
                />
                -->
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col54')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col54')" class="ml-1" style="width:30px"
              :color="component.PEOPLE_NAME_FONT.COLOR" 
              path="PEOPLE_NAME_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col54')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_NAME_FONT.PCSIZE" 
              path="PEOPLE_NAME_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col54')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_NAME_FONT.MBSIZE" 
              path="PEOPLE_NAME_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col54')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_NAME_FONT.LINEHEIGHT" 
              path="PEOPLE_NAME_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.PEOPLE_NAME_FONT.ALIGN" 
              path="PEOPLE_NAME_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.PEOPLE_NAME_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>          
          
          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col112')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col112')" class="ml-1" style="width:30px"
              :color="component.PEOPLE_AFF_FONT.COLOR" 
              path="PEOPLE_AFF_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col112')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_AFF_FONT.PCSIZE" 
              path="PEOPLE_AFF_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col112')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_AFF_FONT.MBSIZE" 
              path="PEOPLE_AFF_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col112')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_AFF_FONT.LINEHEIGHT" 
              path="PEOPLE_AFF_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.PEOPLE_AFF_FONT.ALIGN" 
              path="PEOPLE_AFF_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.PEOPLE_AFF_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>               

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col55')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col55')" class="ml-1" style="width:30px"
              :color="component.PEOPLE_DESC_FONT.COLOR" 
              path="PEOPLE_DESC_FONT.COLOR" :obj="component"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagemain_col55')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_DESC_FONT.PCSIZE" 
              path="PEOPLE_DESC_FONT.PCSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagemain_col55')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_DESC_FONT.MBSIZE" 
              path="PEOPLE_DESC_FONT.MBSIZE" :obj="component"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagemain_col55')" class="ml-1" style="width:30px"
              :size="component.PEOPLE_DESC_FONT.LINEHEIGHT" 
              path="PEOPLE_DESC_FONT.LINEHEIGHT" :obj="component"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px"
              :align="component.PEOPLE_DESC_FONT.ALIGN" 
              path="PEOPLE_DESC_FONT.ALIGN" :obj="component"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="component.PEOPLE_DESC_FONT" 
              @callback="callback_fontvalue"
              />                       
          </div>            

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagemain_col108')}}</div>
            <dialogcolor 
              dense :title="$t('pagemain_col108')" class="ml-1" style="width:30px"
              :color="component.PEOPLE_BGCOLOR" 
              path="PEOPLE_BGCOLOR" :obj="component"
              @callback="callback_value"
              />
          </div>

          <div class="input_title w-100 mt-2 mb-2">{{$t('pagemain_col56')}}</div>  
          <draggable v-model="component.PEOPLELIST" :group="'poster'" handle=".handle" @change="changedragupdate">
          <div v-for="(item, index) in component.PEOPLELIST" :key="index">

            <div class="mt-1" style="height:120px">
              <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                  @click="fileSelect(`COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`, 200, 270)"
                  >
                  <img 
                    height="120"
                    :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`)"
                    class="image" style="cursor:pointer"
                    />
                  <v-icon class="handle" style="position:absolute; bottom:8px; left:8px;cursor:pointer">mdi-drag</v-icon>
                  <v-icon style="position:absolute; bottom:8px; right:8px;cursor:pointer" @click.stop="delete_people(component, item)">mdi-delete</v-icon>
                  <v-icon style="position:absolute; bottom:8px; right:38px; cursor:pointer;">
                    mdi-pencil
                  </v-icon>
              </div>
            </div>        

            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col57')}}</div>
              <v-textarea
                v-model="item.PEOPLE_NAME" 
                outlined class="ml-2"
                style="white-space:pre-line;width:100%"
                rows="3" bg-color="#ffffff" 
                type="text" color="#FF6000"
                :placeholder="$t('pagemain_col58')"
                dense single-line hide-details
                />
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col112')}}</div>
              <v-textarea
                v-model="item.PEOPLE_AFF" 
                outlined class="ml-2"
                style="white-space:pre-line;width:100%"
                rows="3" bg-color="#ffffff" 
                type="text" color="#FF6000"
                :placeholder="$t('pagemain_col112')"
                dense single-line hide-details
                />
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col59')}}</div>
              <v-textarea
                v-model="item.PEOPLE_DESC" 
                outlined class="ml-2"
                style="white-space:pre-line;width:100%"
                rows="3" bg-color="#ffffff" 
                type="text" color="#FF6000"
                :placeholder="$t('pagemain_col60')"
                dense single-line hide-details
                />
            </div>

          </div>
          </draggable>

          <div class="d-flex justify-center mt-2">
            <v-btn @click="add_people_info(component)">{{$t('pagemain_col61')}}</v-btn> 
          </div>            

        </template>
        <!--- 이미지 배너 -->
        <template v-else-if="component.COMPONENT_TYPE == 'BANNER'">
          
          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col21')}}</label>
            <v-select 
              v-model="component.BANNER_ANITYPE" :items="BANNERANITYPELIST" :placeholder="$t('pagemain_col21')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
          </div>            
          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col62')}}</label>
            <v-select 
              v-model="component.BANNER_TIME" :items="TIMETYPELIST" :placeholder="$t('pagemain_col62')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
          </div>            

          <div class="input_title w-100 mt-2 mb-2">{{$t('pagemain_col63')}}</div>  
          <draggable v-model="component.BANNERLIST" :group="'poster'" handle=".handle" @change="changedragupdate">
          <div v-for="(item, index) in component.BANNERLIST" :key="index">

            <div class="mt-1" style="height:120px">
              <div style="cursor:pointer;height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
                  @click="fileSelect(`COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`, 598, 400)"
                  >
                  <img 
                    height="120"
                    :src="getNestedProperty(previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`)"
                    class="image" style="cursor:pointer"
                    @click="showImage(previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`)"
                    />
                  <v-icon class="handle" style="position:absolute; bottom:8px; left:8px;cursor:pointer">mdi-drag</v-icon>
                  <v-icon style="position:absolute; bottom:8px; right:8px;cursor:pointer" @click.stop="delete_banner(component, item)">mdi-delete</v-icon>
                  <v-icon style="position:absolute; bottom:8px; right:38px; cursor:pointer;">
                    mdi-pencil
                  </v-icon>
              </div>
            </div>        
          
          </div>
          </draggable>

          <div class="d-flex justify-center mt-2">
            <v-btn @click="add_banner_info(component)">{{$t('pagemain_col64')}}</v-btn> 
          </div>            

        </template>
        <template v-else-if="component.COMPONENT_TYPE == 'BUTTON'">

          <div class="d-flex flex-row mt-2">
            <label class="input_title">{{$t('pagemain_col101')}}</label>
            <v-select 
              v-model="component.BUTTON_ALIGN" :items="ALIGNTYPELIST" :placeholder="$t('pagemain_col22')" 
              item-text="name" item-value="value" outlined dense 
              hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
              bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
              />
          </div>            

          <!-- 버튼 -->
          <div class="input_title w-100 mt-2 mb-2">{{$t('pagemain_col99')}}</div>
          <div v-for="(item, index) in component.BUTTONLIST" :key="index">

            <div class="d-flex flex-row">
              <label class="input_title">{{$t('pagemain_col92')}}</label>
              <v-select 
                v-model="item.BTNTYPE" :items="BTNTYPELIST" :placeholder="$t('pagemain_col92')" 
                :item-text="$i18n.locale == 'ko' ? 'name' : 'name2'"
                item-value="value" outlined dense @change="changedragupdate"
                hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
                bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
                />
                <v-spacer/>
                <v-icon @click="delete_button(component, item)">mdi-delete</v-icon>  
            </div>

            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col90')}}</div>
              <input
                v-model="item.BTNNAME" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagemain_col91')"
                />
              <dialogcolor 
                dense :title="$t('pagemain_col90')" class="ml-1" style="width:30px"
                :color="item.BTNNAME_FONT.COLOR" :obj="item"
                path="BTNNAME_FONT.COLOR" 
                @callback="callback_value"
                />
              <dialogfontsize 
                dense :title="$t('pagemain_col90')" class="ml-1" style="width:30px"
                :size="item.BTNNAME_FONT.PCSIZE" :obj="item"
                path="BTNNAME_FONT.PCSIZE"
                @callback="callback_value"
                />                
              <dialogfontsize2
                dense :title="$t('pagemain_col90')" class="ml-1" style="width:30px"
                :size="item.BTNNAME_FONT.MBSIZE" :obj="item"
                path="BTNNAME_FONT.MBSIZE"
                @callback="callback_value"
                />                
              <dialoglineheight
                dense :title="$t('pagemain_col90')" class="ml-1" style="width:30px"
                :size="item.BTNNAME_FONT.LINEHEIGHT" :obj="item"
                path="BTNNAME_FONT.LINEHEIGHT"
                @callback="callback_value"
                />                
              <dialogfontalign                               
                dense style="width:30px"
                :align="item.BTNNAME_FONT.ALIGN" :obj="item"
                path="BTNNAME_FONT.ALIGN"
                @callback="callback_value"
                />
              <dialogfont class="ml-1" style="width:400px"
                :comidx="SEARCH_COM_IDX" 
                :font="item.BTNNAME_FONT" 
                @callback="callback_fontvalue"
                />                
            </div>

            <div class="d-flex flex-row mt-2" v-if="item.BTNTYPE < 2">
              <div class="input_title">{{$t("pagemain_col93")}}</div>
              <input
                v-model="item.BTNLINK" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagemain_col94')"
                />
            </div>
  

            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col95')}}</div>
              <dialogcolor 
                dense :title="$t('pagemain_col95')" class="ml-1" style="width:30px"
                :color="item.BTNCOLOR" :obj="item"
                path="BTNCOLOR" 
                @callback="callback_value"
                />
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col96')}}</div>
              <dialogfontsize 
                dense :title="$t('pagemain_col96')" class="ml-1" style="width:30px"
                :size="item.BTNPCROUND" :obj="item"
                path="BTNPCROUND"
                @callback="callback_value"
                />                
              <dialogfontsize2
                dense :title="$t('pagemain_col96')" class="ml-1" style="width:30px"
                :size="item.BTNMBROUND" :obj="item"
                path="BTNMBROUND"
                @callback="callback_value"
                />                
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagemain_col97')}}</div>
              <dialogcolor 
                dense :title="$t('pagemain_col97')" class="ml-1" style="width:30px"
                :color="item.BTNLINECOLOR" :obj="item"
                path="BTNLINECOLOR" 
                @callback="callback_value"
                />
              <dialogfontsize 
                dense :title="$t('pagemain_col98')" class="ml-1" style="width:30px"
                :size="item.BTNPCWIDTH" :obj="item"
                path="BTNPCWIDTH"
                @callback="callback_value"
                />                
              <dialogfontsize2
                dense :title="$t('pagemain_col98')" class="ml-1" style="width:30px"
                :size="item.BTNMBWIDTH" :obj="item"
                path="BTNMBWIDTH"
                @callback="callback_value"
                />                
            </div>
            <v-divider class="mt-3 mb-3"/>
          </div>

          <div class="d-flex justify-center mt-2">
            <v-btn @click="add_button_info(component)">{{$t('pagemain_col100')}}</v-btn> 
          </div>            

        </template>
        <template v-else-if="component.COMPONENT_TYPE == 'TABLE'">
          <!-- 사용안함 -->
          <div class="d-flex flex-row">
            <div class="input_title">행개수</div>
            <input
              v-model="component.TABLE_ROWS" type="number"
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              placeholder="PC 공백높이를 입력하세요"
              />
          </div>
          <div class="d-flex flex-row mt-2">
            <div class="input_title">열개수</div>
            <input
              v-model="component.TABLE_COLS" type="number"
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              placeholder="MB 공백높이를 입력하세요"
              />
          </div>
          <div class="d-flex justify-center mt-2">
            <v-btn @click="generateTable(component)">테이블 생성</v-btn> 
          </div>            

          <table v-if="component.TABLELIST != null && component.TABLELIST.length > 0" border="1" class="mt-5" style="width:100%;border-collapse: collapse;">
            <tr v-for="(row, rowIndex) in component.TABLELIST" :key="rowIndex">
              <td
                v-for="(cell, colIndex) in row"
                :key="colIndex"           
                style="position:relative"
                >
                <textarea v-model="cell.CELL_TEXT"  style="width:100%;height:100%;text-align: center;" 

                  />
                <v-icon style="position:absolute; bottom:8px; left:8px;cursor:pointer">mdi-drag</v-icon>
              </td>
            </tr>
          </table>            

        </template>
        <template v-else-if="component.COMPONENT_TYPE == 'SPACE'">
          <div class="d-flex flex-row">
            <div class="input_title_nowidth" style="width:200px">{{$t('pagemain_col65')}}</div>
            <input
              v-model="component.SPACE_PC_HEIGHT" type="number"
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col66')"
              />
          </div>
          <div class="d-flex flex-row mt-2">
            <div class="input_title_nowidth"  style="width:200px">{{$t('pagemain_col67')}}</div>
            <input
              v-model="component.SPACE_MB_HEIGHT" type="number"
              class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
              :placeholder="$t('pagemain_col68')"
              />
          </div>
        </template>

        <v-divider color="black" class="mt-3"/>

      </v-col>
      </draggable>

      <v-col cols="12" class="d-flex justify-center align-center mt-5 mb-10 pa-0">
        <v-btn @click="add_component" color="primary">{{$t('pagemain_col104')}}</v-btn>
      </v-col>
      

    </v-col>
        
      

    </v-row>
  </v-container>
</template>

<script>
  import draggable from 'vuedraggable'
  import VueCropper from 'vue-cropperjs'; //이미지 크롭
  import 'cropperjs/dist/cropper.css';
  
  //import cmvalidation from '../assets/js/cmvalidation.js'
  
  export default {

    components: {
      draggable, VueCropper
    },

    methods: {


      setComponentModel(type){

        let obj = null;
        if(type == "TITLE"){
          obj = {
                  COMPONENT_TYPE: "TITLE"
                , TITLE:""
                , TITLE_FONT:{
                    NAME:"나눔고딕"
                  , CODE:"나눔고딕"
                  , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                  , PCSIZE: 36
                  , MBSIZE: 24
                  , LINEHEIGHT: 120
                  , COLOR: "#4f6ef7ff"
                  , ALIGN: "left"
                }
          }
        }else if(type == "TEXT"){
          obj = {
                COMPONENT_TYPE: "TEXT"
              , TEXT:""
              , TEXT_FONT:{
                  NAME:"NotoSans-Regular"
                , CODE:"NotoSans-Regular"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/1/font/1730242926867.ttf"
                , PCSIZE: 18
                , MBSIZE: 18
                , LINEHEIGHT: 120
                , COLOR: "#747474FF"
                , ALIGN: "left"
              }
          }
        }else if(type == "POSTER"){
          obj = {
                COMPONENT_TYPE: "POSTER"
              , POSTER_ANITYPE: "none"
              , POSTER_ALIGN: "center"
              , POSTER_TITLE_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 32
                , MBSIZE: 32
                , LINEHEIGHT: 120
                , COLOR: "#ffffffff"
                , ALIGN: "left"
              }
              , POSTER_DESC_FONT:{
                  NAME:"NotoSans-Regular"
                , CODE:"NotoSans-Regular"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/1/font/1730242926867.ttf"
                , PCSIZE: 16
                , MBSIZE: 16
                , LINEHEIGHT: 120
                , COLOR: "#AAAAAAFF"
                , ALIGN: "left"
              }
              , POSTER_BTN_USE:1
              , POSTER_BTN:""
              , POSTER_EFFECT: 1

              , POSTER_BTNCOLOR:"#FFFFFF00"
              , POSTER_BTNPCROUND:3
              , POSTER_BTNMBROUND:3
              , POSTER_BTNLINECOLOR:"#555555FF"
              , POSTER_BTNPCWIDTH:1
              , POSTER_BTNMBWIDTH:1

              , POSTER_BTN_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 14
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#D7D7D7FF"
                , ALIGN: "left"
              }
              , POSTERLIST:[]
          }
        }else if(type == "SPLIT"){
          obj = {
                COMPONENT_TYPE: "SPLIT"
              , PCBG_TYPE:0
              , PCBG_URL:""
              , MBBG_TYPE:0
              , MBBG_URL:""
              , SPLIT_TITLE:""
              , SPLIT_TITLE_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 36
                , MBSIZE: 24
                , LINEHEIGHT: 120
                , COLOR: "#4F6EF7FF"
                , ALIGN: "left"
              }
              , SPLIT_DESC:""
              , SPLIT_DESC_FONT:{
                  NAME:"Noto Sans"
                , CODE:"Noto Sans"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NotoSans-Regular.ttf"
                , PCSIZE: 18
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#747474FF"
                , ALIGN: "left"
              }
              , SPLIT_DIVTYPE:"5:5"       //나누기 비율
              , SPLIT_LEFTCONTENT:"text/image"   //왼쪽에 먼저 나와야 하는 컨텐츠
              , SPLIT_BTN_USE:1
              , SPLIT_BTN:""
              , SPLIT_BTN_URL:""
              , SPLIT_BTN_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 16
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#FFFFFFFF"
                , ALIGN: "center"
              }

          }
        }else if(type == "NOTICE"){
          obj = {
                COMPONENT_TYPE: "NOTICE"
              , NOTICE_TITLE_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 18
                , MBSIZE: 16
                , LINEHEIGHT: 120
                , COLOR: "#D7D7D7FF"
                , ALIGN: "left"
              }
              , NOTICE_DESC_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 16
                , MBSIZE: 16
                , LINEHEIGHT: 120
                , COLOR: "#7F7F7FFF"
                , ALIGN: "left"
              }
            , NOTICELIST:[]
          }
        }else if(type == "IMAGE"){
          obj = {
                COMPONENT_TYPE: "IMAGE"
              , PCBG_URL:""
              , MBBG_URL:""             
          }
        }else if(type == "PEOPLE"){
          obj = {
                COMPONENT_TYPE: "PEOPLE"
              , PEOPLE_ANITYPE: "none"
              , PEOPLE_ALIGN: "center"
              , PEOPLE_BGCOLOR: "#00000000"
              , PEOPLE_NAME_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 20
                , MBSIZE: 20
                , LINEHEIGHT: 120
                , COLOR: "#FFFFFFFF"
                , ALIGN: "left"
              }
              , PEOPLE_AFF_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 14
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#858585FF"
                , ALIGN: "left"
              }
              , PEOPLE_DESC_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 14
                , MBSIZE: 14
                , LINEHEIGHT: 120
                , COLOR: "#858585FF"
                , ALIGN: "left"
              }
              , PEOPLELIST:[]
          }
        }else if(type == "BANNER"){
          obj = {
                COMPONENT_TYPE: "BANNER"
              , BANNER_ANITYPE: "fadein"
              , BANNER_TIME:3
              , BANNERLIST:[]
          }
        }else if(type == "BUTTON"){
          obj = {
              COMPONENT_TYPE: "BUTTON",
              BUTTON_ALIGN: "center",
              BUTTONLIST:[]
          }
        }else if(type == "TABLE"){
          obj = {
                COMPONENT_TYPE: "TABLE"
              , TABLE_ROWS:4
              , TABLE_COLS:4
              , TABLELIST:[]
          }
        }else if(type == "SPACE"){
          obj = {
                COMPONENT_TYPE: "SPACE"
              , SPACE_PC_HEIGHT:10
              , SPACE_MB_HEIGHT:10
          }
        }

        return obj;
      },

      add_poster_info(cp){
        const obj = {
            POSTER_IMAGE:""
          , POSTER_INDEX:""
          , POSTER_TITLE:""
          , POSTER_DESC:""
          , POSTER_LINK:""
        }
        obj.POSTER_INDEX = Date.now().toString();
        cp.POSTERLIST.push(obj);
        this.$forceUpdate();
      },

      add_people_info(cp){
        const obj = {
            PEOPLE_IMAGE:""
          , PEOPLE_INDEX:""
          , PEOPLE_NAME:""
          , PEOPLE_AFF:""
          , PEOPLE_DESC:""
        }
        obj.PEOPLE_INDEX = Date.now().toString();
        cp.PEOPLELIST.push(obj);
        this.$forceUpdate();
      },

      add_notice_info(cp){
        const obj = {
            NOTICE_TITLE:""
          , NOTICE_DESC:""
        }
        cp.NOTICELIST.push(obj);
        this.$forceUpdate();
      },

      add_banner_info(cp){
        const obj = {
            BANNER_IMAGE:""
          , BANNER_INDEX:""
        }
        obj.BANNER_INDEX = Date.now().toString();
        cp.BANNERLIST.push(obj);
        this.$forceUpdate();
      },

      add_button_info(cp){
        const obj = {
              BTNNAME:""
            , BTNNAME_FONT:{
                NAME:"나눔고딕"
              , CODE:"나눔고딕"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
              , PCSIZE: 20
              , MBSIZE: 16
              , LINEHEIGHT: 100
              , COLOR: "#FFFFFFFF"
              , ALIGN: "center"
            }
            , BTNCOLOR: "#3F55C9FF"
            , BTNLINECOLOR: "#00000000"
            , BTNPCROUND: 10
            , BTNMBROUND: 10
            , BTNPCWIDTH: 1
            , BTNMBWIDTH: 1
            , BTNTYPE: 0
            , BTNLINK: ""
        }
        obj.BUTTON_INDEX = Date.now().toString();
        cp.BUTTONLIST.push(obj);
        this.$forceUpdate();
      },

      generateTable(cp){

        cp.TABLELIST = Array.from({ length: cp.TABLE_ROWS }, () =>
          Array.from({ length: cp.TABLE_COLS }, () => ({
            CELL_TEXT: "", // 셀 텍스트
            CELL_FONT: {
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , SIZE: 18
                , COLOR: "#000000ff"
                , ALIGN: "center"
            },
            CELL_BG: "#ffffff",
            ROW_SPAN:1,
            COL_SPAN:1,
          }))
        );

        this.$forceUpdate();

      },

      delete_poster(cp, item){
        this.$confirm(this.$t('pagemain_col80'))
        .then(() => {
          const idx = cp.POSTERLIST.indexOf(item);
          if (idx !== -1) {
            cp.POSTERLIST.splice(idx, 1); // 해당 인덱스에서 1개의 요소 삭제
          }
          this.$forceUpdate();
        });
      },

      delete_people(cp, item){
        this.$confirm(this.$t('pagemain_col81'))
        .then(() => {
          const idx = cp.PEOPLELIST.indexOf(item);
          if (idx !== -1) {
            cp.PEOPLELIST.splice(idx, 1); // 해당 인덱스에서 1개의 요소 삭제
          }
          this.$forceUpdate();
        });
      },

      delete_notice(cp, item){
        this.$confirm(this.$t('pagemain_col82'))
        .then(() => {
          const idx = cp.NOTICELIST.indexOf(item);
          if (idx !== -1) {
            cp.NOTICELIST.splice(idx, 1); // 해당 인덱스에서 1개의 요소 삭제
          }
          this.$forceUpdate();
        });
      },

      delete_banner(cp, item){
        this.$confirm(this.$t('pagemain_col83'))
        .then(() => {
          const idx = cp.BANNERLIST.indexOf(item);
          if (idx !== -1) {
            cp.BANNERLIST.splice(idx, 1); // 해당 인덱스에서 1개의 요소 삭제
          }
          this.$forceUpdate();
        });
      },

      delete_button(cp, item){
        this.$confirm(this.$t('pagemain_col87'))
        .then(() => {
          const idx = cp.BUTTONLIST.indexOf(item);
          if (idx !== -1) {
            cp.BUTTONLIST.splice(idx, 1); // 해당 인덱스에서 1개의 요소 삭제
          }
          this.$forceUpdate();
        });
      },

      changetype(cp){
        const idx = cp.INDEX;
        const newobj = this.setComponentModel(cp.COMPONENT_TYPE);
        newobj.INDEX = idx;
        Object.keys(cp).forEach(key => delete cp[key]); //기존 객체의 모든 값 제거
        Object.assign(cp, newobj);                      //신규 값 복사
        this.$forceUpdate();
      },
      

      showsite(){
        window.open("https://fairpass.co.kr?ecode="+this.SEARCH_EVENT_IDX, "_blank");
      },

      callback_fontvalue(value, obj){
        let target      = obj;
        target.NAME     = value.NAME;
        target.CODE     = value.CODE;
        target.FONTURL  = value.FONTURL;
        this.$forceUpdate();
      },

      callback_value(value, path, obj){

        //this.editedItem 기준의 path

        const keys = path.split('.');
        let target = obj;

        for (let i = 0; i < keys.length - 1; i++) {
          // 배열 인덱스 처리
          const key = keys[i].match(/^(\w+)\[(\d+)\]$/);
          if (key) {
            const arrayKey = key[1]; // 배열 이름
            const index = parseInt(key[2], 10); // 배열 인덱스

            // 배열이 없으면 생성
            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            // 인덱스 위치에 객체가 없으면 생성
            if (!target[arrayKey][index]) {
              target[arrayKey][index] = {};
            }

            target = target[arrayKey][index];
          } else {
            // 일반 객체 처리
            if (!target[keys[i]]) {
              target[keys[i]] = {};
            }
            target = target[keys[i]];
          }
        }        

        // 마지막 키에 값 설정
        const lastKey = keys[keys.length - 1];
        const lastKeyMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);
        if (lastKeyMatch) {
          const arrayKey = lastKeyMatch[1];
          const index = parseInt(lastKeyMatch[2], 10);

          if (!target[arrayKey]) {
            target[arrayKey] = [];
          }

          target[arrayKey][index] = value;
        } else {
          target[lastKey] = value;
        }        
      
        this.$forceUpdate();

      },

      changedragupdate(){
        //console.log(`${e.moved.oldIndex} / ${e.moved.newIndex}`);
        //this.editedItem.PAGE_INFO.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        //this.editedItem.PAGE_INFO.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
        this.$forceUpdate();
      },

      //오리지널 리스트 순서를 변경
      changedrag(e){
        
        this.editedItem.PAGE_INFO.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        this.editedItem.PAGE_INFO.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
      },



      //한글설정정보 가져오기
      loadinfo(){
        this.$confirm(this.$t('pagesetinfo_col60'))
        .then(() => {
          this.loadinfoeng();
        });
      },

      loadinfoeng(){

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.items.splice(0, this.items.length);   //데이터 초기화
          this.editedItem = {};

            this.loading = true;
            this.$http.post(this.$host+'/api/getPageMain',
              {
                  ADMIN_IDX : this.$session.get("ADMIN_IDX")
                , COM_IDX : this.SEARCH_COM_IDX
                , EVENT_IDX : this.SEARCH_EVENT_IDX
                , LAN_CODE:this.$i18n.locale
              },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                //메인페이지 설정 정보
                if(result.data.resultData.length == 0){

                  //최초
                  this.editedItem = Object.assign({}, this.defaultItem);

                }else{

                  //로드한 경우
                  this.editedItem = Object.assign({}, this.defaultItem);

                  if(result.data.resultData[0].PAGE_INFO_ENG_TEMP != null && result.data.resultData[0].PAGE_INFO_ENG_TEMP != undefined){
                    this.editedItem.PAGE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].PAGE_INFO_ENG_TEMP));

                    this.editedItem.PAGE_INFO.forEach(element => {

                      //섹션 이미지 미리보기 로드
                      this.setNestedProperty(this.previewImg, `SECTION.${element.INDEX}.PCBG_URL`, element.PCBG_URL);
                      this.setNestedProperty(this.previewImg, `SECTION.${element.INDEX}.MBBG_URL`, element.MBBG_URL);

                      for(const component of element.COMPONENT){

                        if(component.COMPONENT_TYPE == "IMAGE"){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

                        }else if(component.COMPONENT_TYPE == "POSTER"){
                          for(const item of component.POSTERLIST){
                            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`, item.POSTER_IMAGE);
                          }

                        }else if(component.COMPONENT_TYPE == "SPLIT"){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

                        }else if(component.COMPONENT_TYPE == "PEOPLE"){
                          for(const item of component.PEOPLELIST){
                            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`, item.PEOPLE_IMAGE);
                          }

                        }else if(component.COMPONENT_TYPE == "BANNER"){
                          for(const item of component.BANNERLIST){
                            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`, item.BANNER_IMAGE);
                          }

                        }

                      }
                      
                    });

                    
                  }

                }


                this.loading = false;

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.loading = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }
              
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
                this.loading = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });          


      },                    



      //한글설정정보 가져오기
      loadinfo_deploy(){
        this.$confirm(this.$t('pagesetinfo_col64'))
        .then(() => {
          this.load_deploy();
        });
      },


      load_deploy(){

        this.items.splice(0, this.items.length);   //데이터 초기화
        this.editedItem = {};

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

          this.loading = true;
          this.$http.post(this.$host+'/api/getPageMain',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , COM_IDX : this.SEARCH_COM_IDX
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              //메인페이지 설정 정보
              if(result.data.resultData.length == 0){

                //최초
                this.editedItem = Object.assign({}, this.defaultItem);

              }else{

                //로드한 경우
                this.editedItem = Object.assign({}, this.defaultItem);

                //this.editedItem.PAGELOGO = result.data.resultInfo[0].PAGELOGO;
                //this.previewImg[0] = result.data.resultInfo[0].PAGELOGO;
                if(result.data.resultData[0].PAGE_INFO != null && result.data.resultData[0].PAGE_INFO != undefined){
                  this.editedItem.PAGE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].PAGE_INFO));

                  this.editedItem.PAGE_INFO.forEach(element => {

                    //섹션 이미지 미리보기 로드
                    this.setNestedProperty(this.previewImg, `SECTION.${element.INDEX}.PCBG_URL`, element.PCBG_URL);
                    this.setNestedProperty(this.previewImg, `SECTION.${element.INDEX}.MBBG_URL`, element.MBBG_URL);

                    for(const component of element.COMPONENT){

                      if(component.COMPONENT_TYPE == "IMAGE"){
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

                      }else if(component.COMPONENT_TYPE == "POSTER"){
                        for(const item of component.POSTERLIST){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`, item.POSTER_IMAGE);
                        }

                      }else if(component.COMPONENT_TYPE == "SPLIT"){
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

                      }else if(component.COMPONENT_TYPE == "PEOPLE"){
                        for(const item of component.PEOPLELIST){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`, item.PEOPLE_IMAGE);
                        }

                      }else if(component.COMPONENT_TYPE == "BANNER"){
                        for(const item of component.BANNERLIST){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`, item.BANNER_IMAGE);
                        }

                      }

                    }
                    
                  });

                  
                }

              }


              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },


      deploy_popup(){
          this.$confirm(this.$t('pagesetinfo_col65'))
          .then(() => {
            this.deploy();
          });
      },      

      //추가 저장
      async deploy () {

          this.progress_dialog = true;
          this.$http.post(this.$host+'/api/PageMainDeploy',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then(async(result)=>{

              this.progress_dialog = false;
              
              if(result.data.resultCode == 0){

                  //토큰 저장
                  if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                      this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                  }
                  if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                      this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                  }
                  this.$alert(this.$t('common_process_msg')).then(()=>{
                      //this.loadpage();
                  });

              }else if(result.data.resultCode == 2){
                  //로그인 필요
                  this.$alert(this.$t("common_tokener"));
                  this.$session.clear("ADMIN_IDX");
                  this.$session.clear("COM_IDX");
                  this.$session.clear("ACNT_IDX");
                  this.$session.clear("GRADE");
                  this.$session.clear("COM_NAME");
                  this.$session.clear("ACCESSTOKEN");
                  this.$session.clear("REFLASHTOKEN");
                  this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                  this.$alert(this.$t('deviceadminbg_msg8'));
              }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.progress_dialog = false;
              this.$alert(this.$t("common_insert_fail"));
          });

      },        

      async save(){


        //섹션 이미지 저장
        for (let i = 0; i < this.editedItem.PAGE_INFO.length; i++) {

          const section = this.editedItem.PAGE_INFO[i];
          const imgflag1 = await this.checkimgupload(`${section.TITLE} ${this.$t('pagemain_col7')}`, `${section.INDEX}_PCBGIMG`, `SECTION.${section.INDEX}.PCBG_URL`, `PAGE_INFO[${i}].PCBG_URL`);
          if(!imgflag1){
            if(section.PCBG_TYPE == 2){
              if(section.PCBG_URL == null || section.PCBG_URL == undefined || section.PCBG_URL.length == 0){
                this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col7')}<br>${this.$t('common_img')}`});
                return;
              }
            }
          }
          const imgflag2 = await this.checkimgupload(`${section.TITLE} ${this.$t('pagemain_col11')}`, `${section.INDEX}_MBBGIMG`, `SECTION.${section.INDEX}.MBBG_URL`, `PAGE_INFO[${i}].MBBG_URL`);
          if(!imgflag2){
            if(section.MBBG_TYPE == 2){
              if(section.MBBG_URL == null || section.MBBG_URL == undefined || section.MBBG_URL.length == 0){
                this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col11')}<br>${this.$t('common_img')}`});
                return;
              }
            }
          }

          //컴포넌트 이미지 저장
          for(let j=0; j < section.COMPONENT.length ; j++){

            const component = section.COMPONENT[j];

            if(component.COMPONENT_TYPE == "IMAGE"){

              const imgflag1 = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col75')}`, `${component.INDEX}_PCBGIMG`, `COMPONENT.${component.INDEX}.PCBG_URL`, `PAGE_INFO[${i}].COMPONENT[${j}].PCBG_URL`);
              if(!imgflag1){
                if(component.PCBG_URL == null || component.PCBG_URL == undefined || component.PCBG_URL.length == 0){
                  this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col51')}<br>${this.$t('common_img')}`});
                  return;
                }
              }
              const imgflag2 = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col75')}`, `${component.INDEX}_MBBGIMG`, `COMPONENT.${component.INDEX}.MBBG_URL`, `PAGE_INFO[${i}].COMPONENT[${j}].MBBG_URL`);
              if(!imgflag2){
                if(component.MBBG_URL == null || component.MBBG_URL == undefined || component.MBBG_URL.length == 0){
                  this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col52')}<br>${this.$t('common_img')}`});
                  return;
                }
              }

            }else if(component.COMPONENT_TYPE == "POSTER"){
              
              for(let k=0; k < component.POSTERLIST.length ; k++){
                const posterflag = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col72')}`, `${component.POSTERLIST[k].POSTER_INDEX}_POSTER_IMAGE`, `COMPONENT.${component.INDEX}.POSTERLIST.${component.POSTERLIST[k].POSTER_INDEX}.POSTER_IMAGE`, `PAGE_INFO[${i}].COMPONENT[${j}].POSTERLIST[${k}].POSTER_IMAGE`);
                if(!posterflag){
                  if(component.POSTERLIST[k].POSTER_IMAGE == null || component.POSTERLIST[k].POSTER_IMAGE == undefined || component.POSTERLIST[k].POSTER_IMAGE.length == 0){
                    this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col29')}<br>${this.$t('common_img')}`});
                    return;
                  }
                }
              }

            }else if(component.COMPONENT_TYPE == "SPLIT"){
              const imgflag1 = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col73')}`, `${component.INDEX}_PCBGIMG`, `COMPONENT.${component.INDEX}.PCBG_URL`, `PAGE_INFO[${i}].COMPONENT[${j}].PCBG_URL`);
              if(!imgflag1){
                if(component.PCBG_TYPE == 0){
                  if(component.PCBG_URL == null || component.PCBG_URL == undefined || component.PCBG_URL.length == 0){
                    this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col44')}<br>${this.$t('common_img')}`});
                    return;
                  }
                }
              }
              const imgflag2 = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col73')}`, `${component.INDEX}_MBBGIMG`, `COMPONENT.${component.INDEX}.MBBG_URL`, `PAGE_INFO[${i}].COMPONENT[${j}].MBBG_URL`);
              if(!imgflag2){
                if(component.MBBG_TYPE == 0){
                  if(component.MBBG_URL == null || component.MBBG_URL == undefined || component.MBBG_URL.length == 0){
                    this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col46')}<br>${this.$t('common_img')}`});
                    return;
                  }
                }
              }
            }else if(component.COMPONENT_TYPE == "PEOPLE"){
              for(let k=0; k < component.PEOPLELIST.length ; k++){
                const peopleflag = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col76')}`, `${component.PEOPLELIST[k].PEOPLE_INDEX}_PEOPLE_IMAGE`, `COMPONENT.${component.INDEX}.PEOPLELIST.${component.PEOPLELIST[k].PEOPLE_INDEX}.PEOPLE_IMAGE`, `PAGE_INFO[${i}].COMPONENT[${j}].PEOPLELIST[${k}].PEOPLE_IMAGE`);
                if(!peopleflag){
                  if(component.PEOPLELIST[k].PEOPLE_IMAGE == null || component.PEOPLELIST[k].PEOPLE_IMAGE == undefined || component.PEOPLELIST[k].PEOPLE_IMAGE.length == 0){
                    this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col76')}<br>${this.$t('common_img')}`});
                    return;
                  }
                }
              }

            }else if(component.COMPONENT_TYPE == "BANNER"){
              for(let k=0; k < component.BANNERLIST.length ; k++){
                const bannerflag = await this.checkimgupload(`${section.TITLE}/${this.$t('pagemain_col77')}`, `${component.BANNERLIST[k].BANNER_INDEX}_BANNER_IMAGE`, `COMPONENT.${component.INDEX}.BANNERLIST.${component.BANNERLIST[k].BANNER_INDEX}.BANNER_IMAGE`, `PAGE_INFO[${i}].COMPONENT[${j}].BANNERLIST[${k}].BANNER_IMAGE`);
                if(!bannerflag){
                  if(component.BANNERLIST[k].BANNER_IMAGE == null || component.BANNERLIST[k].BANNER_IMAGE == undefined || component.BANNERLIST[k].BANNER_IMAGE.length == 0 ){
                    this.$fire({html:`${this.$t('pagemain_col1')}:${section.TITLE}<br>${this.$t('pagemain_col77')}<br>${this.$t('common_img')}`});
                    return;
                  }
                }
              }
            }

          }


        }
        

        //순서 처리
        /*
        var tempidx = 1;
        this.items.forEach(item=>{
          item.PAGE_SORT = tempidx;
          tempidx++;
        });
        */

        //json형식이 올바른지 체크 - 양식이 깨지면 전송금지.
        /*
        try {
          const jsonString = JSON.stringify(this.editedItem.PAGE_INFO);
          JSON.parse(jsonString); // 파싱 가능하면 유효한 JSON
        } catch (error) {
          console.error("Invalid JSON format:", error);
          this.$alert("저장데이터가 파손되어 저장할 수 없습니다.");
          return;
        } 
        */       


        this.loading = true;
        this.$http.post(this.$host+'/api/PageMainUpdate',
          {
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , COM_IDX: this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
            , PAGE_INFO: JSON.stringify(this.editedItem.PAGE_INFO)
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          this.loading = false;
          this.progress_dialog = false;
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
              this.$alert(this.$t('eventinfo_msg17')).then(()=>{
                //this.loadpage();
              });


          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eventinfo_msg18'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
            this.loading = false;
            this.progress_dialog = false;
            this.$alert(this.$t('eventinfo_msg18'));
        });
        
      },

      add_section(){

        this.$prompt(this.$t('pagemain_col84')).then(text => {
          // do somthing with text
          const section =  {
                              USETYPE: 1
                            , USEFIX: 1
                            , INDEX: -1
                            , PCBG_TYPE:0
                            , PCBG_URL:""
                            , PCBG_COLOR:""
                            , MBBG_TYPE:0
                            , MBBG_URL:""
                            , MBBG_COLOR:""
                            , TITLE:""
                            , PC_LEFT:0
                            , PC_TOP:0
                            , PC_RIGHT:0
                            , PC_BOTTOM:0
                            , MB_LEFT:0
                            , MB_TOP:0
                            , MB_RIGHT:0
                            , MB_BOTTOM:0
                            , COMPONENT:[]
                          };
          section.TITLE = text;
          section.INDEX = Date.now().toString();
          this.editedItem.PAGE_INFO.push(section);
          this.PARENT_ITEM = section;
        });        

      },

      delete_section(section){
        this.$confirm(this.$t('pagemain_col85'))
        .then(() => {

          const index = this.editedItem.PAGE_INFO.indexOf(section);
          if (index !== -1) {
            this.editedItem.PAGE_INFO.splice(index, 1); // 해당 인덱스에서 1개의 요소 삭제
            this.PARENT_ITEM = null;
          }


        });
      },

      copy_component(origin){

        this.$confirm(this.$t('pagemain_col107'))
        .then(() => {

          const component = JSON.parse(JSON.stringify(origin));
          component.INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);

          if(component.COMPONENT_TYPE == "IMAGE"){
            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

          }else if(component.COMPONENT_TYPE == "POSTER"){
            for(const item of component.POSTERLIST){
              item.POSTER_INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`, item.POSTER_IMAGE);
            }

          }else if(component.COMPONENT_TYPE == "SPLIT"){
            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
            this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

          }else if(component.COMPONENT_TYPE == "PEOPLE"){
            for(const item of component.PEOPLELIST){
              item.PEOPLE_INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`, item.PEOPLE_IMAGE);
            }

          }else if(component.COMPONENT_TYPE == "BANNER"){
            for(const item of component.BANNERLIST){
              item.BANNER_INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`, item.BANNER_IMAGE);
            }

          }

          this.PARENT_ITEM.COMPONENT.push(component);

        });

      },

      delete_component(component){

        this.$confirm(this.$t('pagemain_col86'))
        .then(() => {

          const index = this.PARENT_ITEM.COMPONENT.indexOf(component);
          if (index !== -1) {
            this.PARENT_ITEM.COMPONENT.splice(index, 1); // 해당 인덱스에서 1개의 요소 삭제
          }

        });

      },

      add_component(){

        const index = Date.now().toString();

        this.PARENT_ITEM.COMPONENT.push({
            COMPONENT_TYPE: "TITLE"
          , INDEX: index
          , TITLE:""
          , TITLE_FONT:{
              NAME:"나눔고딕"
            , CODE:"나눔고딕"
            , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
            , PCSIZE: 36
            , MBSIZE: 16
            , LINEHEIGHT: 120
            , COLOR: "#4f6ef7ff"
          }
        });

      },

      loadpage(){

        this.items.splice(0, this.items.length);   //데이터 초기화
        this.editedItem = {};

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

          this.loading = true;
          this.$http.post(this.$host+'/api/getPageMain',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , COM_IDX : this.SEARCH_COM_IDX
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              //메인페이지 설정 정보
              if(result.data.resultData.length == 0){

                //최초
                this.editedItem = Object.assign({}, this.defaultItem);

              }else{

                //로드한 경우
                this.editedItem = Object.assign({}, this.defaultItem);

                //this.editedItem.PAGELOGO = result.data.resultInfo[0].PAGELOGO;
                //this.previewImg[0] = result.data.resultInfo[0].PAGELOGO;
                if(result.data.resultData[0].PAGE_INFO_TEMP != null && result.data.resultData[0].PAGE_INFO_TEMP != undefined){
                  this.editedItem.PAGE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].PAGE_INFO_TEMP));

                  this.editedItem.PAGE_INFO.forEach(element => {

                    //섹션 이미지 미리보기 로드
                    this.setNestedProperty(this.previewImg, `SECTION.${element.INDEX}.PCBG_URL`, element.PCBG_URL);
                    this.setNestedProperty(this.previewImg, `SECTION.${element.INDEX}.MBBG_URL`, element.MBBG_URL);

                    for(const component of element.COMPONENT){

                      if(component.COMPONENT_TYPE == "IMAGE"){
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

                      }else if(component.COMPONENT_TYPE == "POSTER"){
                        for(const item of component.POSTERLIST){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`, item.POSTER_IMAGE);
                        }

                      }else if(component.COMPONENT_TYPE == "SPLIT"){
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
                        this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

                      }else if(component.COMPONENT_TYPE == "PEOPLE"){
                        for(const item of component.PEOPLELIST){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`, item.PEOPLE_IMAGE);
                        }

                      }else if(component.COMPONENT_TYPE == "BANNER"){
                        for(const item of component.BANNERLIST){
                          this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`, item.BANNER_IMAGE);
                        }

                      }

                    }
                    
                  });

                  
                }

              }


              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){

        //첫페이지 로드
        this.loadpage();

      },



      loaddetail(item){
        this.PARENT_ITEM  = item;
        this.PARENT_INDEX = this.editedItem.PAGE_INFO.indexOf(item);

        //추가데이터 호환 작업
        for(const cp of this.PARENT_ITEM.COMPONENT){
          if(cp.COMPONENT_TYPE == "PEOPLE"){
            if(cp.PEOPLE_AFF_FONT == undefined){
              cp.PEOPLE_AFF_FONT = { ...this.setComponentModel("PEOPLE") };
            }
          }else if(cp.COMPONENT_TYPE == "POSTER"){
            if(cp.POSTER_BTNCOLOR == undefined){
              cp.POSTER_BTNCOLOR = "#FFFFFF00";
              cp.POSTER_BTNPCROUND = 3;
              cp.POSTER_BTNMBROUND = 3;
              cp.POSTER_BTNLINECOLOR = "#555555FF";
              cp.POSTER_BTNPCWIDTH = 1;
              cp.POSTER_BTNMBWIDTH = 1;
            }
          }
        }

      },

      cancel_crop(){
        this.crop_dialog = false;
      },

      copy(section){

        this.$confirm(this.$t('pagemain_col106'))
        .then(() => {
          
          const newItem = JSON.parse(JSON.stringify(section));
          newItem.TITLE = newItem.TITLE + " copy";
          newItem.INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);

          //섹션 이미지 미리보기 로드
          this.setNestedProperty(this.previewImg, `SECTION.${newItem.INDEX}.PCBG_URL`, newItem.PCBG_URL);
          this.setNestedProperty(this.previewImg, `SECTION.${newItem.INDEX}.MBBG_URL`, newItem.MBBG_URL);

          for(const component of newItem.COMPONENT){

            component.INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);

            if(component.COMPONENT_TYPE == "IMAGE"){
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

            }else if(component.COMPONENT_TYPE == "POSTER"){
              for(const item of component.POSTERLIST){
                item.POSTER_INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);
                this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.POSTERLIST.${item.POSTER_INDEX}.POSTER_IMAGE`, item.POSTER_IMAGE);
              }

            }else if(component.COMPONENT_TYPE == "SPLIT"){
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PCBG_URL`, component.PCBG_URL);
              this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.MBBG_URL`, component.MBBG_URL);

            }else if(component.COMPONENT_TYPE == "PEOPLE"){
              for(const item of component.PEOPLELIST){
                item.PEOPLE_INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);
                this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.PEOPLELIST.${item.PEOPLE_INDEX}.PEOPLE_IMAGE`, item.PEOPLE_IMAGE);
              }

            }else if(component.COMPONENT_TYPE == "BANNER"){
              for(const item of component.BANNERLIST){
                item.BANNER_INDEX = Date.now().toString()+"_"+Math.floor(Math.random() * 1000000);
                this.setNestedProperty(this.previewImg, `COMPONENT.${component.INDEX}.BANNERLIST.${item.BANNER_INDEX}.BANNER_IMAGE`, item.BANNER_IMAGE);
              }

            }

          }          


          this.editedItem.PAGE_INFO.push(newItem);

        });

      },

      cropimg(){

          this.crop_dialog = false;
          this.$refs.cropper_land.getCroppedCanvas().toBlob((blob) => {
            this.setNestedProperty(this.uploadFile, this.photo_key, blob);
          });
          
          this.setNestedProperty(this.previewImg, this.photo_key, this.$refs.cropper_land.getCroppedCanvas().toDataURL("image/jpeg"));

      },              

      showImage(obj, path){

        const value = this.getNestedProperty(obj, path);

        if(!value){
            return;
        }
          
        this.$viewerApi({
            options: {
                zIndex:9999
            },          
            images: [value]
        });

      },  

      fileSelect(key, width, height){

          const changefunction = this.selectfile;
          var input = document.createElement("input");
          input.style = "display:none";
          input.name = "imageinputcamera";
          input.type = "file";
          input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

          /* 크롭사이즈 변경 */
          if(width != null && height != null){
            this.option.autoCropWidth  = width;
            this.option.autoCropHeight = height;
            this.option.aspectRatio = width/height;
            this.option.fixed = true;
          }else{
            this.option.autoCropWidth  = NaN;
            this.option.autoCropHeight = NaN;
            this.option.aspectRatio = NaN;
            this.option.fixed = false;
          }
          this.$forceUpdate();

          let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
          if(indexcnt > -1){
              //아이폰, 아이패드, 맥
              //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
              document.body.appendChild(input);
              input.onchange = function (event) {
                  document.body.removeChild(input);
                  changefunction(event.target.files[0], key);
              };
          }else{
              input.onchange = function (event) {
                  changefunction(event.target.files[0], key);
              };
          }
          input.click();
      },            

      //아이콘에서 파일 변경시
      selectfile(file, key){

          if(file.size/1024/1024 > 10){
              this.$alert(this.$t('eul_msg101'));
              this.setNestedProperty(this.uploadFile, key, null);
              //this.uploadFile[key] = null;
              return;
          }

          const reader = new FileReader();
          reader.onload = (event)=>{
            this.photo_key    = key;
            this.crop_dialog  = true;
            this.imgSrc       = event.target.result;  //이게 blob데이터
            this.$refs.cropper_land.replace(event.target.result);
          }
          reader.readAsDataURL(file);  //비동기로 파일을 읽어서

      },      

      fitCropToImage() {
        if (this.$refs.cropper_land) {

          // 이미지와 캔버스 데이터 가져오기
          const imageData = this.$refs.cropper_land.getImageData();
          const canvasData = this.$refs.cropper_land.getCanvasData();    

          // 현재 표시된 이미지 영역 계산
          const displayedWidth  = imageData.width;
          const displayedHeight = imageData.height;
          const left  = canvasData.left;
          const top   = canvasData.top;
    
          // 현재 표시된 이미지에 맞게 크롭 박스 설정
          this.$refs.cropper_land.setCropBoxData({
            left: left,
            top: top,
            width: displayedWidth,
            height: displayedHeight
          });     

        }      
      },

      /**
       * 이미지 업로드
       * @param {number} korname   - 업로드 구분값 (오류시 보여줌)
       * @param {number} imgparam  - 저장할 파일명 이름 
       * @param {number} uploadpath - uploadFile에 저장된 이미지의 path 
       * @param {number} savepath   - editedItem에 저장할 path 
       */        
      async checkimgupload(korname, imgparam, uploadpath, savepath){
        
          const s3obj     = this.$s3;
          const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
          var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.

          // s3에 폴더 생성
          // eslint-disable-next-line no-unused-vars
          await s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
              if(err2) {
                  //앨범생성 오류
                  this.$alert(this.$t('eventinfo_msg16'));
                  return false;
              }
          });   

          //파일이 지정된 경우
          const filevalue = this.getNestedProperty(this.uploadFile, uploadpath);
          if(filevalue){

              this.progress_dialog = true;            
              let imgpath;
              let curdate = Date.now().toString();    //무조건 신규 파일명으로 그래야 디자인 갱신됨.
              imgpath  = `${imgparam}_${curdate}.jpg`;
              
              var photoKey = albumPhotosKey + imgpath;                 //최종 경로

              const stored = await s3obj.upload({
                                                      Bucket: "blueorigin-mice-image",
                                                      Key: photoKey,
                                                      Body: filevalue,
                                                      ACL: "public-read"
                                                  }).promise();

              if(stored == null || stored.Location == null){

                  this.progress_dialog = false;
                  this.$fire({ 
                      html:`${this.$t('common_process_fail')} <br> ${korname}`
                  });
                  return false;
              }
              this.progress_dialog = false;
              
              this.setNestedProperty(this.uploadFile, uploadpath, null);
              this.setNestedProperty(this.editedItem, savepath, stored.Location);          //////////////////////
              return true;

          }else{
            //파일이 없으면면
            this.progress_dialog = false;
            return false;
          }

      },


      //obj의 path에 값을 저장한다. path는 프로퍼티, 배열인덱스 가능
      setNestedProperty(obj, path, value) {

        const keys = path.split('.'); // 경로를 점(.)으로 분리
        let target = obj;

        for (let i = 0; i < keys.length - 1; i++) {

          // 배열 인덱스 처리
          const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
          if (arrayMatch) {
            const arrayKey = arrayMatch[1]; // 배열 이름
            const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

            // 배열이 없으면 생성
            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            // 배열의 인덱스에 객체가 없으면 생성
            if (!target[arrayKey][index]) {
              target[arrayKey][index] = {};
            }

            target = target[arrayKey][index]; // 다음 단계로 이동
          } else {
            // 일반 객체 처리
            if (!target[keys[i]]) {
              target[keys[i]] = {}; // 키가 없으면 객체 생성
            }
            target = target[keys[i]]; // 다음 단계로 이동
          }
        }

        // 마지막 키에 값 설정
        const lastKey = keys[keys.length - 1];
        const lastArrayMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);

        if (lastArrayMatch) {
          const arrayKey = lastArrayMatch[1];
          const index = parseInt(lastArrayMatch[2], 10);

          if (!target[arrayKey]) {
            target[arrayKey] = [];
          }

          target[arrayKey][index] = value;
        } else {
          target[lastKey] = value;
        }
      },

      //obj의 특정 path에서 값을 가져온다.
      getNestedProperty(obj, path) {
        
        const keys = path.split('.'); // 경로를 점(.)으로 분리
        let target = obj;

        for (let i = 0; i < keys.length; i++) {
          // 배열 인덱스 처리
          const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
          if (arrayMatch) {
            const arrayKey = arrayMatch[1]; // 배열 이름
            const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

            if (!target[arrayKey] || !Array.isArray(target[arrayKey]) || !target[arrayKey][index]) {
              return undefined; // 배열 또는 인덱스가 유효하지 않으면 undefined 반환
            }
            target = target[arrayKey][index];
          } else {
            // 일반 객체 처리
            if (!target[keys[i]]) {
              return undefined; // 키가 없으면 undefined 반환
            }
            target = target[keys[i]];
          }
        }

        return target; // 최종 값을 반환
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        
        this.PARENT_ITEM = null;
        this.PARENT_INDEX = -1;
        this.loadpage();
        
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        
        this.items.splice(0, this.items.length);   //데이터 초기화
        this.PARENT_ITEM = null;
        this.PARENT_INDEX = -1;

      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.items.splice(0, this.items.length);   //데이터 초기화
          this.PARENT_ITEM = null;
          this.PARENT_INDEX = -1;

      },



    },

    beforeMount(){
      //로드전에 객체화 (경고 메시지 안나오게)
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
      }
    },

    computed: {
      formTitle () {
        //수정 팝업 제목의 신규와 수정을 구분하기 위함
        return this.editedIndex === -1 ? this.$t('eventformat_msg15') : this.$t('eventformat_msg16')
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    beforeDestroy(){
      //아이폰의 경우 찌거기 제거
      let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
      if(indexcnt > -1){
          let elements = document.getElementsByName("imageinputcamera");
          for(var i=0, len=elements.length ; i != len; ++i){
              elements[0].parentNode.removeChild(elements[0]);
          }
      }
    },      

    data () {
      return {

        loading : false,    //로딩 표시
        loading2 : false,   //로딩 표시
        
        //pagination: {},     //페이징 정보가 들어가는 듯. 알아서 들어감. 

        editedIndex: -1,
        editedIndex2: -1,

        dialog : false,
        

        headers: [
          {text: '', align: 'center', sortable: false, value: '', width:'50px'},
          {text: '섹션', align: 'center', sortable: false, value: 'PAGE_NAME', width:'230px'},
          {text: '복사', align: 'center', sortable: false, value: 'COPY', width:'80px'},
          {text: '사용여부', align: 'center', sortable: false, value: 'USETYPE',width:'80px'},
        ],
        items: [],
        
        defaultItem: {
          PAGE_INFO: []
        },

        editedItem: {},
        
        PARENT_ITEM: {},
        PARENT_INDEX: -1,
        items2: [],
        editedItem2: {},        

        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',
        grade : 0,
        
        USETYPELIST: [
            {name:'None',    value:0}
          , {name:'Use',     value:1}
        ],

        SHOWTYPELIST: [
            {name:'Hide',    value:0}
          , {name:'Show',    value:1}
        ],

        BTNUSETYPELIST: [
            {name:'Off',    value:0}
          , {name:'On',     value:1}
        ],

        SPLITTYPELIST:[
            {name:'텍스트/이미지(영상)', name2:'Text/Image(Video)',    value:"text/image"}
          , {name:'이미지(영상)/텍스트', name2:'Image(Video)/Text',    value:"image/text"}
        ],

        DIVTYPELIST:[
            {name:'5:5',    value:"5:5"}
          , {name:'6:4',    value:"6:4"}
          , {name:'4:6',    value:"4:6"}
          , {name:'7:3',    value:"7:3"}
          , {name:'3:7',    value:"3:7"}
        ],

        ANITYPELIST:[
            {name:'None',         value:"none"}
          , {name:'FadeIn',       value:"fadein"}
          , {name:'Left Slide',     value:"leftslide"}
          , {name:'Top Slide',     value:"topslide"}
        ],

        BANNERANITYPELIST:[
            {name:'FadeIn',       value:"fadein"}
          , {name:'Left Slide',     value:"leftslide"}
        ],

        TIMETYPELIST:[
            {name:'1s',     value:1}
          , {name:'2s',     value:2}
          , {name:'3s',     value:3}
          , {name:'4s',     value:4}
          , {name:'5s',     value:5}
          , {name:'6s',     value:6}
          , {name:'7s',     value:7}
          , {name:'8s',     value:8}
          , {name:'9s',     value:9}
          , {name:'10s',    value:10}
        ],

        ALIGNTYPELIST:[
            {name:'LEFT',    value:"left"}
          , {name:'CENTER',  value:"center"}
          , {name:'RIGHT',    value:"right"}
        ],

        BGTYPELIST: [
            {name:'BASIC',       value:0}
          , {name:'COLOR',       value:1}
          , {name:'IMAGE',     value:2}
        ],

        URLTYPELIST: [
            {name:'BASIC',       value:0}
          , {name:'COLOR',       value:1}
          , {name:'IMAGE',     value:2}
        ],

        CONTENTTYPELIST: [
            {name:'IMAGE',    value:0}
          , {name:'YOUTUBE',  value:1}
        ],


        VIDEOTYPELIST:[
            {name:'YOUTUBE',  value:0}
        ],

        BTNTYPELIST:[
            {name:'링크',     name2:'LINK',     value:0}
          , {name:'다운로드', name2:'DOWNLOAD',    value:1}
          , {name:'등록 신청', name2:'REGISTER',     value:2}
          , {name:'등록 정보 확인', name2:'CONFIRM REGISTRATION', value:3}
        ],

        CPTYPELIST:[
            {name:'타이틀', name2:"TITLE",    value:"TITLE"}
          , {name:'텍스트', name2:"TEXT",        value:"TEXT"}
          , {name:'포스터', name2:"POSTER",        value:"POSTER"}
          , {name:'분할내용', name2:"SPLIT",      value:"SPLIT"}
          , {name:'게시글', name2:"POSTS",        value:"NOTICE"}
          , {name:'단일이미지', name2:"IMAGE",     value:"IMAGE"}
          , {name:'연사소개', name2:"SPEAKERS",       value:"PEOPLE"}
          , {name:'이미지 슬라이드', name2:"Image Carousel​",     value:"BANNER"}
          , {name:'버튼', name2:"BUTTON",         value:"BUTTON"}
          , {name:'공백', name2:"Spacing",          value:"SPACE"}
        ],

        progress_dialog : false,    //로딩 표시
        progress_value:0,

        //이미지 크롭
        crop_dialog: false,
        imgSrc:'',
        s3: null,   //aws

        uploadFile : {},
        photo_key: 0,
        previewImg : {},      //이미지 미리보기

        //신규 크롭 파라메터
        option: {
            img: "",
            outputSize: 1,
            outputType: "jpg",
            canMove: true,
            fixed: true,                  //크롭박스 비율 고정
            aspectRatio: 100/100,
            fixedBox: false,      //true면 크롭박스 크기 조절 안됨
            original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
            canMoveBox: true,
            autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
            autoCropWidth:100,    //크롭박스의 가로 크기 fixed가 true면 비율대로
            autoCropHeight:100,   //크롭박스의 세로 크기 
            centerBox: true,
            high: false,
            cropData: {},
            enlarge: 1,
            mode: 'contain',
            maxImgSize: 5000,
            limitMinSize: [1000, 300]
        },

      }
    }
  }
</script>
<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>  
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  li {
    display: inline;
  }

  .pagination{
    margin: 0px;
  }


</style>
